import React, { Component } from 'react';
import '../settings.css';
import TagsByInput from '../../TagsAndChips/TagsByInput';
import ImageGalleryField from '../../../ImageGalleryField';
import { showNotification } from '../../../StatusNotification';
import { showConfirmation } from '../../../ConfirmationModal';

export class EventSettings extends Component {
    static displayName = EventSettings.name;

    constructor(props) {
        super(props);
        this.state = {
            eventConfiguration: null,
            removedTags: [],
            typeColors: {}
        };
        this.onTypeTagRemoval = this.onTypeTagRemoval.bind(this);
        this.handleColorChange = this.handleColorChange.bind(this);
        this.addNewType = this.addNewType.bind(this);
        this.addEventType = this.addEventType.bind(this);
        this.removeEventType = this.removeEventType.bind(this);
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleChange = (e) => {
        let newEventConfiguration = this.state.eventConfiguration;
        newEventConfiguration[e.target.name] = e.target.value;
        this.setState({ eventConfiguration: newEventConfiguration });
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let eventConfiguration = this.state.eventConfiguration;
        
        // Save type colors to localStorage
        localStorage.setItem('eventTypeColors', JSON.stringify(this.state.typeColors));

        fetch('AdminSettings/UpdateEventSettingsData', {
            method: 'POST',
            body: JSON.stringify(eventConfiguration),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (data === "Saved") {
                    if (this.state.removedTags.length > 0) {
                        let removedTags = this.state.removedTags;
                        for (var i = 0; i < removedTags.length; i++) {
                            let tag = removedTags[i];
                            fetch('AdminEvent/RemoveEventTypeReference?typeToRemove=' + tag, {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Accept': 'application/json'
                                }
                            });
                        }
                    }

                    this.props.onComponentSaved();
                }
                else {
                    showNotification(data, "error");
                }
            }
        )
    }

    async onTypeTagRemoval(tag) {
        let removedTags = this.state.removedTags;
        removedTags.push(tag);
        
        // Remove color mapping for the removed tag
        let typeColors = { ...this.state.typeColors };
        delete typeColors[tag];
        
        this.setState({ removedTags: removedTags, typeColors: typeColors });
    }

    handleColorChange(typeName, color) {
        let typeColors = { ...this.state.typeColors };
        typeColors[typeName] = color;
        this.setState({ typeColors: typeColors });
        
        // Save to localStorage immediately
        localStorage.setItem('eventTypeColors', JSON.stringify(typeColors));
    }

    addNewType(typeName) {
        // Assign a default color to new types
        const defaultColors = [
            "#FF0000", "#00FF00", "#0000FF", "#FFFF00", "#FF00FF", "#00FFFF", "#800000", "#808000", 
            "#008000", "#800080", "#008080", "#000080", "#FFA500", "#A52A2A", "#DC143C", "#00CED1"
        ];
        
        let typeColors = { ...this.state.typeColors };
        if (!typeColors[typeName]) {
            const existingColorCount = Object.keys(typeColors).length;
            typeColors[typeName] = defaultColors[existingColorCount % defaultColors.length];
            this.setState({ typeColors: typeColors });
        }
    }

    addEventType() {
        if (this.newTypeInput && this.newTypeInput.value.trim()) {
            const newTypeName = this.newTypeInput.value.trim();
            
            // Get current types
            let eventConfiguration = { ...this.state.eventConfiguration };
            let types = [];
            if (eventConfiguration.types) {
                try {
                    types = JSON.parse(eventConfiguration.types);
                } catch (e) {
                    // If it fails, treat it as a comma-separated string
                    types = eventConfiguration.types.split(',').map(type => type.trim()).filter(type => type.length > 0);
                }
            }
            
            // Don't add if type already exists
            if (types.includes(newTypeName)) {
                showNotification("Event type already exists!", "error");
                return;
            }
            
            // Add new type
            types.push(newTypeName);
            eventConfiguration.types = JSON.stringify(types);
            
            // Assign default color
            this.addNewType(newTypeName);
            
            // Update state
            this.setState({ eventConfiguration: eventConfiguration });
            
            // Clear input
            this.newTypeInput.value = '';
        }
    }

    async removeEventType(typeName) {
        if (await showConfirmation(`Are you sure you want to remove the event type "${typeName}"?`)) {
            // Remove from types array
            let eventConfiguration = { ...this.state.eventConfiguration };
            let types = [];
            if (eventConfiguration.types) {
                try {
                    types = JSON.parse(eventConfiguration.types);
                } catch (e) {
                    // If it fails, treat it as a comma-separated string
                    types = eventConfiguration.types.split(',').map(type => type.trim()).filter(type => type.length > 0);
                }
            }
            
            types = types.filter(type => type !== typeName);
            eventConfiguration.types = JSON.stringify(types);
            
            // Remove from removed tags (for backend cleanup)
            this.onTypeTagRemoval(typeName);
            
            // Update state
            this.setState({ eventConfiguration: eventConfiguration });
        }
    }

    render() {
        let types = [];
        let defaultImage;

        let isEventConfigurationSet = false;
        if (this.state.eventConfiguration != null) {
            let eventConfiguration = this.state.eventConfiguration;
            if (eventConfiguration.types) {
                try {
                    types = JSON.parse(eventConfiguration.types);
                } catch (e) {
                    // If it fails, treat it as a comma-separated string
                    types = eventConfiguration.types.split(',').map(type => type.trim()).filter(type => type.length > 0);
                }
            }
            defaultImage = eventConfiguration.defaultImage;
            isEventConfigurationSet = true;
        }

        // Render type color pickers
        const typeColorInputs = types.map((type, index) => (
            <div key={type} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', padding: '10px', border: '1px solid #ddd', borderRadius: '4px' }}>
                <input 
                    type="text" 
                    value={type} 
                    readOnly
                    style={{ flex: 1, marginRight: '10px', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
                />
                <input 
                    type="color" 
                    value={this.state.typeColors[type] || '#FF0000'} 
                    onChange={(e) => this.handleColorChange(type, e.target.value)}
                    style={{ width: '50px', height: '40px', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                />
                <button 
                    type="button" 
                    onClick={() => this.removeEventType(type)}
                    style={{ marginLeft: '10px', padding: '8px 12px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                >
                    Remove
                </button>
            </div>
        ));

        return (
            <div className='admin-settings--form'>
                <form onSubmit={this.handleSubmit}>
                    <div className='grid-wrapper'>
                        <div className='dual-grid--offset'>
                            <div className='dual-grid__1-2 form-title'>
                                <h3>Event</h3>
                            </div>

                            <label>Default Image: </label>
                            <input name='defaultImage' type='text' defaultValue={defaultImage} onChange={this.handleChange} required hidden />
                            <ImageGalleryField name='defaultImage' currentImageUrl={defaultImage} handleImageChange={this.handleChange} />

                            <label>Event Types & Colors: </label>
                            <div style={{ marginBottom: '20px' }}>
                                {typeColorInputs}
                                
                                <div style={{ display: 'flex', marginTop: '15px' }}>
                                    <input 
                                        type="text" 
                                        ref={(input) => { this.newTypeInput = input; }}
                                        placeholder="Add new event type..."
                                        style={{ flex: 1, marginRight: '10px', padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
                                    />
                                    <button 
                                        type="button" 
                                        onClick={this.addEventType}
                                        style={{ padding: '8px 16px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                                    >
                                        Add Type
                                    </button>
                                </div>
                            </div>

                            <div className='dual-grid__1-2'>
                                <button type='submit' className='form-button'>Save</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    async getComponentData() {
        const response = await fetch('AdminSettings/GetEventSettingsData', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        // Load type colors from localStorage
        let typeColors = {};
        try {
            const saved = localStorage.getItem('eventTypeColors');
            if (saved) {
                typeColors = JSON.parse(saved);
            }
        } catch (e) {
            console.log("Could not parse saved type colors:", e);
        }

        // If no colors exist, assign default colors to existing types
        if (data.types && Object.keys(typeColors).length === 0) {
            let types = [];
            try {
                // Try to parse as JSON first
                types = JSON.parse(data.types || '[]');
            } catch (e) {
                // If it fails, treat it as a comma-separated string
                console.log("Types is not JSON, parsing as comma-separated string");
                types = data.types.split(',').map(type => type.trim()).filter(type => type.length > 0);
            }
            
            const defaultColors = [
                "#FF0000", "#00FF00", "#0000FF", "#FFFF00", "#FF00FF", "#00FFFF", "#800000", "#808000", 
                "#008000", "#800080", "#008080", "#000080", "#FFA500", "#A52A2A", "#DC143C", "#00CED1"
            ];
            types.forEach((type, index) => {
                typeColors[type] = defaultColors[index % defaultColors.length];
            });
            // Save to localStorage
            localStorage.setItem('eventTypeColors', JSON.stringify(typeColors));
        }

        this.setState({
            eventConfiguration: data,
            typeColors: typeColors
        });
    }
}

export default EventSettings;
